import React from 'react';
import { MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { PrimaryLink, SecondaryLink } from './Buttons';
import { contact } from '../data/contact';
interface FinalCTAProps {
  freeInitialConsultation: boolean;
}
export function FinalCTA({
  freeInitialConsultation
}: FinalCTAProps) {
  return <section aria-labelledby="cta-title" className="relative overflow-hidden border-t border-silver/10 bg-violet-deep py-20 sm:py-28" data-id="element-26" data-mp="84xjodsplwzl">
      <div aria-hidden="true" className="absolute left-1/2 top-1/2 h-80 w-[40rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent/20 blur-[140px]" data-id="element-27" data-mp="m2voosl54h2f" />
      <div className="relative mx-auto w-full max-w-3xl px-5 text-center sm:px-8" data-id="element-28" data-mp="vu8ab2gcib00">
        <h2 id="cta-title" className="font-display text-[1.7rem] font-light leading-tight tracking-[0.05em] text-frost sm:text-4xl" data-id="element-29" data-mp="qwzs51v766yr">
          ¿Deseas conocer nuestras prácticas y servicios? Comunícate con nuestro
          equipo para solicitar una consulta.
        </h2>

        <div className="mt-10 flex flex-col gap-3.5 sm:flex-row sm:justify-center" data-id="element-30" data-mp="2c5y85iig49b9">
          <PrimaryLink href={contact.whatsappHref} className="w-full bg-carbon/70 sm:w-auto" data-id="element-31" data-mp="2h4sq6i8l9tub">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-32" data-mp="2m1j7ta01kxhu" />
            Hablar con un chamán
          </PrimaryLink>
          <SecondaryLink href={contact.phoneHref} className="w-full sm:w-auto" data-id="element-33" data-mp="2v3in9xvertio">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" data-mp="2v1g0dmpjygi6" />
            Llamar ahora
          </SecondaryLink>
        </div>

        {freeInitialConsultation ? <p className="mt-7 text-[0.8rem] uppercase tracking-[0.22em] text-silver" data-id="element-35" data-mp="34un1uwh69ccz">
            Consulta inicial sin costo.
          </p> : null}
      </div>
    </section>;
}